<template>
	<div class="listbox">
		<div class="tabtit">
			<ul>
				<li><router-link to="/MyTailPays">补交尾款</router-link></li>
				<li class="hover"><router-link to="/MyAuc">我的拍卖</router-link></li>
				<li><router-link to="/MyReceive">我的领取</router-link></li>
			</ul>
		</div>
		<div class="tabcont">
			<div class="itembox active">
				<p class="listiti" :data="myaucs" size="mini">
					<span prop="productName" label="物品名称">物品名称</span>
					<span prop="productId" label="物品ID">物品ID</span>
					<span prop="priceMarkupTime" label="竞价时间">竞价时间</span>
					<span prop="paidPrice" label="已付价格" :formatter="formatterPrice">已付价格</span>
					<span prop="unPrice" label="未付价格" :formatter="formatterPrice">未付价格</span>
					<span prop="totalPrice" label="总价价格" :formatter="formatterPrice">总价价格</span>         
					<span prop="isBid" label="是否中标" :formatter="formatterIsBid">是否中标</span>
					<span prop="aucStatus" label="状态" :formatter="formatterStatus">状态</span>
				</p>
				<div class="paimlist">
					<ul>
						<li v-for="item in myaucs" :key="item.id">
							<span class="span1">{{item.productName}}</span>
							<span class="span2">{{item.productId}}</span>
							<span class="span3">{{item.priceMarkupTime}}</span>
							<span class="span4">{{formatterPricelx(item.currencyType,item.paidPrice)}}</span>
							<span class="span5">{{formatterPricelx(item.currencyType,item.unPrice)}}</span>
							<span class="span6">{{formatterPricelx(item.currencyType,item.totalPrice)}}</span>
							<span class="span7">{{formatterIsBidzb(item.isBid)}}</span>
							<span class="span8">{{formatterStatuszt(item.isBid,item.aucStatus)}}</span>
						</li>
					</ul>
				</div>

				<div class="page">
					<el-pagination background @size-change="sizeChange" @current-change="currentChange" layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "MyAuc",
		data() {
			return {
				//访问前缀，用于区分环境，访问api时使用
				service_url: process.env.VUE_APP_SERVICE_URL ? process.env.VUE_APP_SERVICE_URL : "",
				myaucs: [],
				total: 0,
				currentPage: 1,
				currentSize: 10,
			};
		},
	
		methods: {
			sizeChange(size) {
				this.currentSize = size;
				this.initMyAucs();
			},
			currentChange(page) {
				this.currentPage = page;
				this.initMyAucs();
			},
			initMyAucs() {
				this.getRequest(this.service_url + "/aucBid/myAucPage?current=" + this.currentPage + "&size=" + this.currentSize).then((resp) => {
					if (resp) {
						this.myaucs = resp.data.records;
						this.total = resp.data.total;					
					}
				});
			},
			formatterPrice: function(row, column, cellValue) {
				if (row.currencyType == "0" || row.currencyType == 0) {
					return cellValue + "联众币";
				} else if (row.currencyType == "1" || row.currencyType == 1) {
					return cellValue + "游乐豆";
				} else if (row.currencyType == "2" || row.currencyType == 2) {
					return cellValue + "天(会员天数)";
				} else if (row.currencyType == "3" || row.currencyType == 3) {
                    return cellValue + "天(可转移会员天数)";
                }
			},
			formatterTailPricelx: function(currencyType,finalPrice,payMoney) {
				if (currencyType == "0" || currencyType == 0) {
					return (finalPrice - payMoney) + "联众币";
				} else if (currencyType == "1" || currencyType == 1) {
					return (finalPrice - payMoney) + "游乐豆";
				} else if (currencyType == "2" || currencyType == 2) {
					return (finalPrice - payMoney) + "天(会员天数)";
				} else if (currencyType == "3" || currencyType == 3) {
                    return (finalPrice - payMoney) + "天(可转移会员天数)";
                }
			},
			formatterPricelx: function(currencyType,Price) {
				if (currencyType == "0" || currencyType == 0) {
					return Price + "联众币";
				} else if (currencyType == "1" || currencyType == 1) {
					return Price + "游乐豆";
				} else if (currencyType == "2" || currencyType == 2) {
					return Price + "天(会员天数)";
				} else if (currencyType == "3" || currencyType == 3) {
                    return Price + "天(可转移会员天数)";
                }
			},
			formatterIsBid: function(row, column, cellValue) {
				if (cellValue == "0" || cellValue == 0) {
					return "未中标";
				} else if (cellValue == "1" || cellValue == 1) {
					return "中标";
				}
			},
			formatterIsBidzb: function(cellValue) {
				if (cellValue == "0" || cellValue == 0) {
					return "未中标";
				} else if (cellValue == "1" || cellValue == 1) {
					return "中标";
				}
			},
			formatterStatus: function(row, column, cellValue) {
				if (cellValue == "-1" || cellValue == -1) {
					return cellValue + "退款失败";
				} else if (cellValue == "0" || cellValue == 0) {
					if(row.isBid == "1" || row.isBid == 1){
						return "中标用户";
					}
					return "待退款";
				} else if (cellValue == "1" || cellValue == 1) {
					return "已退款";
				}
			},
			formatterStatuszt: function(isBid, cellValue) {
				if (cellValue == "-1" || cellValue == -1) {
					return cellValue + "退款失败";
				} else if (cellValue == "0" || cellValue == 0) {
					if(isBid == "1" || isBid == 1){
						return "中标用户";
					}
					return "待退款";
				} else if (cellValue == "1" || cellValue == 1) {
					return "已退款";
				}
			},
		},
		created() {
			this.initMyAucs();
		}
	};
</script>
<style>
	.listbox { width: 1008px; margin: 0 auto; padding-top: 30px; }
	.tabtit { height: 50px; line-height: 50px; overflow: hidden; border-bottom: 1px #ce2c00 solid; }
	.tabtit ul { height: 50px; line-height: 50px; overflow: hidden; }
	.tabtit li { width: 134px; height: 50px; border: 1px #f0f0f0 solid; text-align: center; line-height: 50px; float: left; color: #151515; font-size: 14px; }
	.tabtit li a { display: block; width: 134px; height: 50px; color: #151515; text-decoration: none; }
	.tabtit li.hover { background: #ce2c00; color: #fff; }
	.tabtit li.hover a { color: #fff; }
	.tabcont { padding-top: 38px; }
	.tabcont .itembox { display: none; width: 958px; margin: 0 auto; }
	.tabcont .active { display: block; }
	.tabcont .itembox .listiti { text-align: center; background: #f2f2f2; color: #333; height: 38px; border: 1px #ccc solid; overflow: hidden; }
	.tabcont .itembox .listiti span { display: block; float: left; width: 119px; text-align: center; line-height: 38px; font-size: 14px; }
	.tabcont .itembox .listitilq { text-align: center; background: #f2f2f2; color: #333; height: 38px; border: 1px #ccc solid; overflow: hidden; }
	.tabcont .itembox .listitilq span { display: block; float: left; width: 95px; text-align: center; line-height: 38px; font-size: 14px; }
	.paimlist { width: 956px; margin: 0 auto; border-left: 1px #dcdcdc solid; border-right: 1px #dcdcdc solid; }
	.paimlist ul {}
	.paimlist ul li { height: 30px; overflow: hidden; line-height: 38px; font-size: 12px; color: #333; border-bottom: 1px #ccc solid; }
	.paimlist ul li span { display: block; text-align: center; line-height: 30px; float: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.paimlist ul li .span1 { width: 115px; }
	.paimlist ul li .span2 { width: 115px; }
	.paimlist ul li .span3 { width: 125px; }
	.paimlist ul li .span4 { width: 118px; }
	.paimlist ul li .span5 { width: 122px; }
	.paimlist ul li .span6 { width: 120px; }
	.paimlist ul li .span7 { width: 123px; }
	.paimlist ul li .span8 { width: 118px; }
	.paimlist ul li .span8 em { display: block; width: 62px; height: 24px; text-align: center; line-height: 24px; color: #fff; font-size: 12px; background: #d90000; margin: 3px auto 0; cursor: pointer; }
	.paimlist ul li:nth-child(even) { background: #f8f8f8; }
	.page { padding: 15px 0; text-align: center; }
	.el-pagination__rightwrapper,.el-pagination__sizes,.el-pagination__jump { display: none; }
	.el-pagination span:not([class*=suffix]) {  display: none; }
	.el-pager li { float: left; }
</style>